import React, { useState } from "react";
import AppLeftSideBar from "../../../components/SideBar/AppLeftSideBar";
import Input from "../../../components/FormComponents/Input";
import Button from "../../../components/FormComponents/Button";
import { useParams } from "react-router-dom";
import UserAssignmentModal from "./components/UserAssignmentModal";
import RoleFormModal from "./components/RoleFormModal";
import RoleTable from "./components/RoleTable";
import { useUserAssignment } from "./hooks/useUserAssignment";
import { useRoleForm } from "./hooks/useRoleForm";
import { useRoles } from "./hooks/useRoles";

const UserRoles = () => {
  const { orgId } = useParams();
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAssignOpen, setIsAssignOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);

  const { roles, createRole, updateRole, deleteRole } = useRoles(orgId);
  const { form, isEdit, editId, resetForm, setEditMode, updateField } = useRoleForm();
  const {
    selectedUsers,
    isLoading: isAssignLoading,
    // fetchRoleUsers,
    searchUsers,
    assignUser,
    removeUser,
    resetUsers
  } = useUserAssignment();

  const filteredRoles = roles.filter((r) => {
    const term = search.toLowerCase();
    return r.name.toLowerCase().includes(term) || r.role_code.toLowerCase().includes(term);
  });

  const handleOpenCreateModal = () => {
    resetForm();
    setIsModalOpen(true);
  };

  const handleOpenEditModal = (role) => {
    setEditMode(role);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    resetForm();
  };

  const handleSubmit = async () => {
    const success = isEdit ? await updateRole(editId, form) : await createRole(form);

    if (success) {
      handleCloseModal();
    }
  };

  // const handleOpenAssignModal = async (role) => {
  //   setSelectedRole(role);
  //   setIsAssignOpen(true);
  //   await fetchRoleUsers(role.id);
  // };

  const handleCloseAssignModal = () => {
    setIsAssignOpen(false);
    setSelectedRole(null);
    resetUsers();
  };

  const handleAssignUser = async (user) => {
    if (user?.id && selectedRole?.id) {
      await assignUser(selectedRole.id, user.id);
    }
  };

  const handleRemoveUser = async (userId) => {
    if (selectedRole?.id) {
      await removeUser(selectedRole.id, userId);
    }
  };

  return (
    <div className="application_container">
      <AppLeftSideBar type="app" />

      <div style={{ padding: 20, width: "100%" }}>
        <h2 className="mb_3">User Roles</h2>

        <div className="flex_column justify_center align_center">
          <div className="d_flex w_100 justify_between mb_3" style={{ maxWidth: "900px" }}>
            <Input
              placeholder="Search by name or code..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              containerStyle={{ maxWidth: "200px" }}
            />

            <Button variant="primary" onClick={handleOpenCreateModal}>
              Add Role
            </Button>
          </div>

          <RoleTable
            roles={filteredRoles}
            onEdit={handleOpenEditModal}
            onDelete={deleteRole}
            // onAssignUsers={handleOpenAssignModal}
          />
        </div>

        <RoleFormModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          form={form}
          isEdit={isEdit}
          onChange={updateField}
          onSubmit={handleSubmit}
        />

        <UserAssignmentModal
          isOpen={isAssignOpen}
          onClose={handleCloseAssignModal}
          isLoading={isAssignLoading}
          assignedUsers={selectedUsers}
          onAssign={handleAssignUser}
          onRemove={handleRemoveUser}
          fetchSearchResults={searchUsers}
        />
      </div>
    </div>
  );
};

export default UserRoles;
